/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'approversEntityPosition';

/** API route prefix — shared by `model.js` (createCrudModel) and list descriptor routes. */
export const FETCH_ROUTE = 'globalEntityApproverByPosition';

/** Singular entity name for `createCrudModel` reducers/notifications. */
export const ENTITY_NAME = 'approverEntityPosition';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'approversEntityPosition';

/** Default list sort — matches legacy `useManageApproverEntityPosition`. */
export const DEFAULT_ORDER_BY = 'dynamicEntity/displayName asc';
